
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/top-5-last-minute-summer-getaways",
      function () {
        return require("private-next-pages/blog/top-5-last-minute-summer-getaways.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/top-5-last-minute-summer-getaways"])
      });
    }
  